export default __webpack_public_path__ + "255d672085211a61bef6d893120dd1d9.png";